module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workOrder"
  }, [_c('div', {
    staticClass: "workOrder-wrap"
  }, [_c('h1', {
    staticClass: "personal-center-form__title"
  }, [_vm._v("角色申请")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(!_vm.userInfo.isFinance || !_vm.userInfo.iscoreCompany || !_vm.userInfo.isThirdParty) ? _c('el-form-item', [(!_vm.userInfo.isThirdParty) ? _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addRole(4)
      }
    }
  }, [_vm._v("我要成为担保方")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.roleList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "roleType",
      "label": "申请角色",
      "align": "center",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requestTime",
      "label": "申请时间",
      "align": "center",
      "min-width": "60",
      "formatter": _vm.formatDate
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requestRemark",
      "label": "备注",
      "align": "center",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审批状态",
      "align": "center",
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.stateMap[scope.row.status]))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleClick(scope.row)
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [(_vm.roleList && _vm.roleList.length > 0) ? _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 10,
      "layout": "total, prev, pager, next",
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "角色申请",
      "visible": _vm.dialogFormVisibleOrder
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisibleOrder = $event
      }
    }
  }, [_c('el-form', {
    ref: "addRoleInfo",
    staticClass: "work_order_add",
    attrs: {
      "model": _vm.addRoleInfo,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邀请码：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入邀请码",
      "width": "100px"
    },
    model: {
      value: (_vm.addRoleInfo.inviteCode),
      callback: function($$v) {
        _vm.$set(_vm.addRoleInfo, "inviteCode", $$v)
      },
      expression: "addRoleInfo.inviteCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-order-height",
    attrs: {
      "label": "备注：",
      "label-width": _vm.formLabelWidth,
      "prop": "requestRemark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "auto-complete": "off",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.addRoleInfo.requestRemark),
      callback: function($$v) {
        _vm.$set(_vm.addRoleInfo, "requestRemark", $$v)
      },
      expression: "addRoleInfo.requestRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisibleOrder = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('addRoleInfo')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5abee0b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/roleApply.vue
// module id = 1021
// module chunks = 1